import { render, staticRenderFns } from "./GField.vue?vue&type=template&id=306f979c&scoped=true&"
import script from "./GField.vue?vue&type=script&lang=js&"
export * from "./GField.vue?vue&type=script&lang=js&"
import style0 from "./GField.vue?vue&type=style&index=0&id=306f979c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f979c",
  null
  
)

export default component.exports